var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-fault-monitor-detail-item-detail"},_vm._l((_vm.getDetails),function(detail,index){return _c('asc-details-item',{key:index,attrs:{"title":detail.title,"value":detail.value}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }